
import { Json } from "@/integrations/supabase/types";
import { SubscriptionFeatures, SubscriptionPlan as LibSubscriptionPlan, SubscriptionPlanType, UserSubscription as LibUserSubscription } from "@/lib/types";

// Re-export types from lib/types for backwards compatibility
export type { SubscriptionFeatures };
export type { SubscriptionPlanType };
export type SubscriptionStatus = "active" | "canceled" | "expired" | "pending";

export interface SubscriptionPlan extends LibSubscriptionPlan {}

export interface UserSubscription extends LibUserSubscription {}

export interface CreateSubscriptionData {
  plan_id: string;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  current_period_end: string;
}

export interface AssignSubscriptionData {
  user_id: string;
  plan_id: string;
  current_period_start: string;
  current_period_end: string;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
}

// Helper function to convert database response to SubscriptionPlan
export const mapDbPlanToSubscriptionPlan = (data: any): SubscriptionPlan => {
  // Ensure features is properly typed and includes document_extraction or default to false
  const rawFeatures = data.features || {};
  
  const features: SubscriptionFeatures = {
    currency_conversion: rawFeatures.currency_conversion || false,
    multiple_currencies: rawFeatures.multiple_currencies || false,
    price_comparison: rawFeatures.price_comparison || false,
    grouped_contracts: rawFeatures.grouped_contracts || false,
    contract_services: rawFeatures.contract_services || false,
    reminders: rawFeatures.reminders || false,
    payment_type_selection: rawFeatures.payment_type_selection || false,
    dashboard: rawFeatures.dashboard || false,
    contract_pdf_email: rawFeatures.contract_pdf_email || false,
    document_extraction: rawFeatures.document_extraction || false
  };
  
  return {
    id: data.id,
    name: data.name,
    description: data.description || '',
    plan_type: data.plan_type,
    monthly_price: data.monthly_price,
    annual_price: data.annual_price || 0,
    features: features,
    is_active: data.is_active,
    show_on_landing: Boolean(data.show_on_landing),
    created_at: data.created_at,
    updated_at: data.updated_at
  };
};
